/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IClientChangesRequestedQueryVariables = Types.Exact<{ [key: string]: never }>;

export type IClientChangesRequestedQuery = {
  __typename?: 'Query';
  clientChangesRequested: {
    __typename?: 'ClientChangesRequestedPayload';
    isRequested: boolean;
    depositor?: {
      __typename?: 'ClientChangesRequested';
      id: string;
      payload?: any | null;
      status: string;
      creator: string;
      receiver: string;
    } | null;
    beneficiary?: {
      __typename?: 'ClientChangesRequested';
      id: string;
      payload?: any | null;
      status: string;
      creator: string;
      receiver: string;
    } | null;
    deposits?: {
      __typename?: 'ClientChangesRequested';
      id: string;
      payload?: any | null;
      status: string;
      creator: string;
      receiver: string;
    } | null;
    notifications?: {
      __typename?: 'ClientChangesRequested';
      id: string;
      payload?: any | null;
      status: string;
      creator: string;
      receiver: string;
    } | null;
    agreement?: {
      __typename?: 'ClientChangesRequested';
      id: string;
      payload?: any | null;
      status: string;
      creator: string;
      receiver: string;
    } | null;
    environment?: {
      __typename?: 'ClientChangesRequested';
      id: string;
      payload?: any | null;
      status: string;
      creator: string;
      receiver: string;
    } | null;
  };
};

export const ClientChangesRequestedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'clientChangesRequested' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientChangesRequested' },
            directives: [{ kind: 'Directive', name: { kind: 'Name', value: 'client' } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isRequested' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'depositor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'payload' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'creator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'receiver' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'beneficiary' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'payload' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'creator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'receiver' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deposits' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'payload' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'creator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'receiver' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'notifications' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'payload' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'creator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'receiver' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agreement' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'payload' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'creator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'receiver' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'environment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'payload' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'creator' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'receiver' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IClientChangesRequestedQuery, IClientChangesRequestedQueryVariables>;
